import React, { useState } from "react";
import './download_app.css'
import { Link } from "react-router-dom";
import Common_title from "../common-title/Common_title";
import Common_download_btn from "../common-download-btn/Common_download_btn";

const Download_app = () => {
    const [isHovered, setIsHovered] = useState(false);
    const [isHoveredImage, setIsHoveredImage] = useState(false);
    const [isHoveredBg, setIsHoveredBg] = useState(false);

    return (
        <>
            <div className="Download_App margin_section">
                <div className="container">
                    <Common_title
                        title={"CAMPUS DEAL "}
                        subtitle={
                            "User Reviews"
                        }
                    />


                    <div
                        className="Download_App_content_holder "
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <div className="row w-100">
                            <div className="col-md-6">
                                <div className="text_content">
                                    <div>
                                        <div className="main_heading_holder">

                                            <h1 className="lefthead">
                                                CAMPUS DEAL 
                                            </h1>

                                            <h1 className="lefthead">
                                                <span>Your Partner in </span>
                                            </h1>

                                            <h1 className="lefthead">
                                                <span>Smart Service Solutions.</span>
                                            </h1>


                                        </div>

                                        <div className="subheading_holder">
                                            <h2>Discover trusted vendors & experts, post site requirements, and manage <br /> all your construction and service needs — right from your phone.</h2>
                                        </div>

                                        <div className="get_app_holder">
                                            <Common_download_btn />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="main-img-holder">
                                    <div
                                        className={`bg-img-holder ${isHovered
                                            ? "rotate-center-bg"
                                            : "rotate-center-bg-Reverse"
                                            }`}
                                        onMouseEnter={() => setIsHoveredBg(true)}
                                        onMouseLeave={() => setIsHoveredBg(false)}
                                    >
                                        <img
                                            className="mobile_bg_img"
                                            src={
                                                process.env.PUBLIC_URL +
                                                "/assets/images/home/download-app/bg.png"
                                            }
                                            alt="mobile_bg_img"
                                        />
                                    </div>

                                    <div className="overlay-img-holder">
                                        <div
                                            className={`img-holder single_mobile ${isHovered ? " rotate-center " : "rotate-center-Reverse"
                                                }`}
                                            onMouseEnter={() => setIsHoveredImage(true)}
                                            onMouseLeave={() => setIsHoveredImage(false)}
                                        >
                                            <img
                                                className="mobile_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/download-app/multi.png"
                                                }
                                                alt="mobile_img"
                                            />
                                        </div>

                                        <div
                                            className={`img-holder grp_mobile ${isHovered ? " rotate-center " : "rotate-center-Reverse"
                                                }`}
                                            onMouseEnter={() => setIsHoveredImage(true)}
                                            onMouseLeave={() => setIsHoveredImage(false)}
                                        >
                                            <img
                                                className="mobile_img"
                                                src={
                                                    process.env.PUBLIC_URL +
                                                    "/assets/images/home/download-app/multi.png"
                                                }
                                                alt="mobile_img"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Download_app